(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyRuleDialogController', CompanyRuleDialogController);

    CompanyRuleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanyRule', 'Customer', 'ServiceItem', 'CompanyCustom', '$translate', '$translatePartialLoader'];

    function CompanyRuleDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanyRule, Customer, ServiceItem, CompanyCustom, translate, translatePartialLoader) {
        var vm = this;

        vm.companyRule = entity;
        vm.clear = clear;
        vm.save = save;
        vm.findCompany = findCompany;


        vm.customField1Translate = "customField1";
        vm.customField2Translate = "customField2";
        vm.customField3Translate = "customField3";

        loadPage();


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function loadPage() {
            translatePartialLoader.addPart('activityType');

            initValue();
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.companyRule.id !== null) {
                CompanyRule.update(vm.companyRule, onSaveSuccess, onSaveError);
            } else {
                CompanyRule.save(vm.companyRule, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyRuleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function findCompany() {

            if (vm.companyKeyUrl) {
                CompanyCustom.findCompanyByKeyURL(vm.companyKeyUrl).query().$promise.then(function (result) {

                    if (result) {
                        vm.companyRule.company = result;
                    }
                })
            }

        }

        function initValue() {
            if (vm.companyRule && vm.companyRule.ruleType) {
                switch (vm.companyRule.ruleType) {
                    case "SSAA_MALEKIAT_API" :
                    case "CLIENT_RESERVE_TIME_LIMIT" :
                    case "SSAA_NOTARY_PERSONNEL" :
                    case "SSAA_INQUIRY_PERSONNEL" :
                    case "SSAA_ORDINARY_PEOPLE" :
                        vm.customField1Translate = "customField1";
                        vm.customField2Translate = "customField2";
                        vm.customField3Translate = "customField3";
                        break;
                    case "SSAA_EJRA":

                        vm.customField1Translate = "UserName";
                        vm.customField2Translate = "Password";
                        vm.customField3Translate = "UnitId";
                        break;

                }
            }
        }

    }
})();
